import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../../../core/services/core.user.service';


@Component({
    selector: 'sa-chat-top',
    template: require('./sachat.top.html')
})
export class StandaloneChatTopComponent implements OnInit {

    @Input() siteConfig: any = null;

    user: any = null;

    constructor(private userService: UserService) { }
    
    ngOnInit() {
        this.user = this.userService.session.getUser();
    }

}